<template>
  <el-drawer :visible.sync="drawer" size="1000px" :with-header="false">
    <div class="item-box-content">
      <div>
        <i class="el-icon-close" style="font-size:22px" @click="onClose"></i>
      </div>
      <div class="title-font-style" style="margin-top:20px;">
        <span>产品信息</span>
      </div>
      <el-table
        style="margin-top:20px;"
        border
        ref="tableRef"
        :data="[productList]"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
      >
        <el-table-column show-overflow-tooltip prop="brandName" label="品牌"></el-table-column>
        <el-table-column show-overflow-tooltip prop="seriesName" label="系列"></el-table-column>
        <el-table-column show-overflow-tooltip prop="proName" label="产品名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="proType" label="型号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="orderNumber" label="订货号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="cbUnit" label="单位"></el-table-column>
        <el-table-column show-overflow-tooltip prop="stockupCount" label="数量"></el-table-column>
      </el-table>
      <div class="title-font-style" style="margin-top:20px;">
        <span>询价供应商</span>
      </div>
      <el-table
        style="margin-top:20px;"
        border
        ref="tableRef"
        :data="[enquiry]"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
      >
        <el-table-column show-overflow-tooltip prop="suName" label="供应商"></el-table-column>
        <el-table-column show-overflow-tooltip prop="stockCount" label="库存数量"></el-table-column>
        <el-table-column show-overflow-tooltip prop="supPrice" label="单品报价"></el-table-column>
        <el-table-column show-overflow-tooltip prop="proPrice" label="产品面价"></el-table-column>
        <el-table-column show-overflow-tooltip prop="extype" label="类型"></el-table-column>
        <el-table-column show-overflow-tooltip prop="extime" label="货期"></el-table-column>
        <el-table-column show-overflow-tooltip prop="source" label="报价来源">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="expire" label="价格有效期" width="100px">
          <template slot-scope="scope">
             {{scope.row.expire|dateFilter}}
          </template>
        </el-table-column>

        <el-table-column show-overflow-tooltip prop="stockupCount" label="采购数量" width="160px">
          <template slot-scope="scope">
            <el-input-number :min="0" controls-position="right" v-model="scope.row.stockupCount"></el-input-number>
          </template>
        </el-table-column>
      </el-table>
      <div class="title-font-style" style="margin-top:20px;">
        <span>其他供应商</span>
      </div>
      <p>仅显示系统内当前有效报价，未提供报价请直接匹配供应商</p>
      <el-form>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item>
              <el-select @change="changeName" v-model="params.column">
                <el-option
                  v-for="(item, index) in expressionName"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-select v-model="params.expression">
              <el-option
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
                v-for="(item, index) in expressionList"
                :key="index"
              ></el-option>
            </el-select>
          </el-col>
          <el-col v-if="params.column === 'expire'" :span="6">
            <el-date-picker v-model="params.value" type="datetime" placeholder="选择日期时间"></el-date-picker>
          </el-col>
          <el-col v-if="params.column !== 'expire'" :span="6">
            <el-input v-model="params.value"></el-input>
          </el-col>
          <el-col :span="6">
            <el-button @click="onSearch" type="primary">搜索</el-button>
            <el-button @click="onSearchReset" type>重置</el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        border
        ref="tableRef"
        :data="productListOther"
        v-el-table-loadmore="loadmore"
        height="378"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
      >
        <el-table-column prop="supplierOffersVo.suName" show-overflow-tooltip label="供应商">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.supplierOfferAndActivitysVo !== null"
              :ref="`popover-${scope.$index}`"
              placement="right"
              width="430"
              trigger="hover"
            >
              <el-form class="details-line-height">
                <p>供应商活动</p>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="品牌：">
                      {{
                      scope.row.supplierOfferAndActivitysVo.brandName
                      }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="返利比例：">
                      {{
                      scope.row.supplierOfferAndActivitysVo.rebatePercentages
                      }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="目标金额：">
                      <span style="color:#C11A1A;">
                        {{
                        scope.row.supplierOfferAndActivitysVo.targetMoney
                        }}
                      </span>元
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="已完成金额：">
                      <span style="color:#C11A1A;">
                        {{
                        scope.row.supplierOfferAndActivitysVo.stocksMoneys
                        }}
                      </span>元
                    </el-form-item>
                  </el-col>
                </el-row>
                <div class="solid"></div>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="系列：">
                      NXC
                      <span style="border: 1px solid #dedede;">正泰</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="返利比例：">2%</el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="目标金额：">
                      <span style="color:#C11A1A;">100000.00</span>元
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="已完成金额：">
                      <span style="color:#C11A1A;">100000.00</span>元
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <div class="el-icon-s-comment" style="font-size:18px;" slot="reference"></div>
              <div style="line-height:14px;" slot="reference">供应商</div>
            </el-popover>
            {{ scope.row.supplierOffersVo.suName }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip  prop="supplierOffersVo.stockCount" label="库存数量"></el-table-column>
        <el-table-column show-overflow-tooltip prop="supplierOffersVo.supPrice" label="单品报价"></el-table-column>
        <el-table-column show-overflow-tooltip prop="supplierOffersVo.proPrice" label="产品面价"></el-table-column>
        <el-table-column show-overflow-tooltip prop="supplierOffersVo.extype" label="类型"></el-table-column>
        <el-table-column show-overflow-tooltip prop="supplierOffersVo.extime" label="货期"></el-table-column>
        <el-table-column show-overflow-tooltip prop="supplierOffersVo.source" label="报价来源">

        </el-table-column>
        <el-table-column show-overflow-tooltip prop="supplierOffersVo.expire" label="价格有效期" width="100px">
           <template slot-scope="scope">
             {{scope.row.supplierOffersVo.expire|dateFilter}}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="supplierOffersVo.stockupCount" label="采购数量" width="160px">
          <template slot-scope="scope">
            <el-input-number :min="0" controls-position="right" v-model="scope.row.supplierOffersVo.stockupCount"></el-input-number>
          </template>
        </el-table-column>
      </el-table>+
      <el-row style="margin-top:20px;">
        <el-col :span="24" style="text-align:center;">
          <el-button @click="onSubmit" type="primary">加入执行区</el-button>
          <el-button @click="onClose">关闭</el-button>
        </el-col>
      </el-row>
    </div>
    <!------------ 确认备货 ------------>
    <open-or-close-dialog
      ref="openOrCloseRefs"
      @onUpdataState="onUpdataState"
      :title="title"
      :content="content"
    ></open-or-close-dialog>
  </el-drawer>
</template>
<script>
import { queryEnquiry } from '@/api/purchase/purchasePlanList'
import OpenOrClose from '@/components/OpenOrClose/index'
import { formatDate } from '@/util/tool'
import { expressionList } from '@/components/utils/data'
// import { delete } from 'vuedraggable'
export default {
  components: {
    'open-or-close-dialog': OpenOrClose
  },
  directives: {
    'el-table-loadmore': {
      bind (el, binding) {
        // 获取element-ui定义好的scroll盒子
        const SELECTWRAP_DOM = el.querySelector(
          '.el-table .el-table__body-wrapper'
        )
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          /**
           * scrollHeight 获取元素内容高度(只读)
           * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
           * clientHeight 读取元素的可见高度(只读)
           * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
           * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
           */
          const condition =
            this.scrollHeight - this.scrollTop <= this.clientHeight
          if (condition) {
            binding.value()
          }
        })
      }
    }
  },
  data () {
    return {
      stockupCount: 0, // 询价供应商的采购数量
      expressionName: [
        { label: '供应商名称', value: 'suName' },
        { label: '库存数量', value: 'stockCount' },
        { label: '单品报价', value: 'supPrice' },
        { label: '价格有效期', value: 'expire' }
      ],
      orderContractStockupPurchasesVo: {},
      enquiry: {},
      productListOther: [],
      drawer: false,
      title: '',
      page: 1,
      size: 30,
      params: {},
      content: '',
      productList: [],
      type: '',
      expressionList: expressionList
    }
  },
  methods: {
    // 重置
    onSearchReset () {
      this.params = {}
      this.mountTable(
        this.productList.proId,
        this.page,
        this.size,
        this.productList.suId,
        this.productList.ocspId,
        true
      )
    },
    // 其他供应商条件改变
    changeName () {
      delete this.params.expression
      delete this.params.value
    },
    // 搜索
    onSearch () {
      this.mountTable(
        this.productList.proId,
        this.page,
        this.size,
        this.productList.suId,
        this.productList.ocspId,
        true
      )
    },
    // 滚动加载更多
    loadmore () {
      this.page++
      this.mountTable(
        this.productList.proId,
        this.page,
        this.size,
        this.productList.suId,
        this.productList.ocspId
      )
      // this.getSupplierList(this.currentPage)
    },
    // 库存详情弹窗初始化
    onInitial (val, index) {
      this.index = index
      this.productList = val
      this.mountTable(
        val.proId,
        this.page,
        this.size,
        val.suId,
        this.productList.ocspId
      )
      this.drawer = true
    },
    mountTable (val, page, size, suId, ocspId, status) {
      if (status === true) {
        this.productListOther = []
        this.page = 1
      }
      const params = {
        criteriaVoList: [this.params],
        queryPageName: ''
      }

      queryEnquiry(val, this.page, this.size, suId, ocspId, params)
        .then((res) => {
          if (res.data.code === 200) {
            res.data.obj.supplierOfferVo.stockupCount = 0
            this.enquiry = res.data.obj.supplierOfferVo
            // this.enquiry.stockupCount = 0
            this.orderContractStockupPurchasesVo =
              res.data.obj.orderContractStockupPurchasesVo
            if (this.page === 1) {
              this.productListOther =
                res.data.obj.supplierOfferAndActivityVoList
            } else {
              const arrList = res.data.obj.supplierOfferAndActivityVoList
              this.productListOther = this.productListOther.concat(arrList)
            }
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 关闭
    onClose () {
      this.drawer = false
    },
    // 确定备货
    onSubmit () {
      const params = JSON.parse(JSON.stringify(this.productListOther))
      let numberNum = 0
      for (let i = 0; i < params.length; i++) {
        if (
          params[i].supplierOffersVo.stockupCount === undefined ||
          params[i].supplierOffersVo.stockupCount === 0
        ) {
          params.splice(i, 1)
          i--
        } else {
          numberNum += params[i].supplierOffersVo.stockupCount
          params[
            i
          ].orderContractStockupPurchasesVo = this.orderContractStockupPurchasesVo
          delete params[i].supplierOfferAndActivitysVo
        }
      }
      const paramsEnquiry = JSON.parse(JSON.stringify(this.enquiry))
      if (paramsEnquiry.stockupCount !== 0) {
        numberNum += paramsEnquiry.stockupCount
        const data = {}
        data.orderContractStockupPurchasesVo = this.orderContractStockupPurchasesVo
        data.supplierOffersVo = paramsEnquiry
        params.push(data)
      }
      if (numberNum > this.productList.stockupCount) {
        this.$message.error('采购总数超出许采购数量')
      } else {
        this.title = '采购计划'
        this.content = '确认添加到采购执行区?'
        this.$refs.openOrCloseRefs.onInitial()
      }
    },
    // 再次确认备货
    onUpdataState () {
      const params = JSON.parse(JSON.stringify(this.productListOther))
      let numberNum = 0
      for (let i = 0; i < params.length; i++) {
        if (
          params[i].supplierOffersVo.stockupCount === undefined ||
          params[i].supplierOffersVo.stockupCount === 0
        ) {
          params.splice(i, 1)
          i--
        } else {
          numberNum += params[i].supplierOffersVo.stockupCount
          params[
            i
          ].orderContractStockupPurchasesVo = this.orderContractStockupPurchasesVo
          delete params[i].supplierOfferAndActivitysVo
        }
      }
      const paramsEnquiry = JSON.parse(JSON.stringify(this.enquiry))
      if (paramsEnquiry.stockupCount !== 0) {
        numberNum += paramsEnquiry.stockupCount
        const data = {}
        data.orderContractStockupPurchasesVo = this.orderContractStockupPurchasesVo
        data.supplierOffersVo = paramsEnquiry
        params.push(data)
      }

      this.$emit('param', params, numberNum, this.index)
      this.drawer = false
    }
  },
  filters: {
    dateFilter
  }
}
function dateFilter (time) {
  if (time === null) {
    return '--'
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
</script>
<style lang="scss" scoped></style>
